import type { Me as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';
import type * as User from './User';

/**
 * `currentUser` resolves `Me` while `saveUser`'s payload resolves `User`. Both describe the
 * same person, so they map into the one `User` domain type rather than forking a second
 * shape the profile form would then have to reconcile — the read and the write of a single
 * field must not disagree about what a user is.
 *
 * Unlike `User.fromGql` this needs no coercion: `Me.id` is already an `Int`.
 */
export const fromGql = (item: GQLItem): User.User =>
  take<User.User>(item, 'id', 'name', 'email');
